// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"root_-5txu"};